<template>
  <div class="main_body_search">
    <div></div>
    <div style="background-color: #dadada;border-radius: 8px">
      <div class="region_box" v-if="$common.getAccountType() === 3">
        <div class="region_item" :class="regionId === 1 ? 'active' : ''" @click="changeRegion(1)">
          国内
        </div>
        <div class="region_item" :class="regionId === 2 ? 'active' : ''" @click="changeRegion(2)">
          海外
        </div>
      </div>
      <div class="main_content" style="border-radius: 8px">
        <div class="main_content_item" :class="showCitySel ? 'sel' : ''" style="border-radius: 8px 0 0 8px">
          <div class="keyword_box" :class="isShowKeyWord ? 'sel' : ''">
           <div style="display: flex;align-items: center;column-gap: 8px">
             <i class="el-icon-location-outline" style="font-size: 18px;color: #99a1af"/>
             <div style="flex: 1">
               <div style="color: #757575;font-size: 13px;margin-top: 6px">
                 酒店名称/目的地
               </div>
               <el-input ref="keyWordInputRef" v-model="keyword" placeholder="输入城市/酒店/地标/商圈"
                         @focus="focusKeyWordInput"
                         size="mini" @input="(event) => inputKeyWord(event, true)" @blur="blurKeyWordInput" clearable
                         style="margin-top: 10px" @clear="clearKeyword">
                 <i slot="suffix" class="el-icon-loading" style="position: absolute;top: 8px;right: 30px"
                    v-if="isSearchHotel"></i>
               </el-input>
             </div>
           </div>
            <HotelKeyWord v-show="isShowKeyWord" :hotelRes="hotelRes" :isLengthError="isLengthError" :regionId="regionId"
                          @toHotelDetail="toHotelDetail" @toHotelList="toHotelList" ref="hotelKeyWordRef"/>
            <div class="new_filter_box" v-show="showHistory && !isShowKeyWord">
              <div style="border-top: 1px solid #d7d7d7">
                <!-- en-->
                <CitySelect :show="showCitySel" :showFilter="showFilter" :keyword="cityInfo.pinyin" @selCity="selCity"
                            @selFilterCity="selCity" v-if="isLang" :regionId="regionId"/>
                <!-- cn -->
                <CitySelect :show="showCitySel" :showFilter="showFilter" :keyword="cityInfo.cityName" @selCity="selCity"
                            @selFilterCity="selCity" v-else :regionId="regionId" @blurInput="blurInput"/>
              </div>
            </div>
            <div class="no_item" style="border-radius: 8px"
                 v-show="isShowKeyWord && !isLengthError && hotelRes && !(hotelRes.poiList && hotelRes.poiList.length)
                 && !(hotelRes.otherCityHotels && hotelRes.otherCityHotels.length)
                 && !(hotelRes.cities && hotelRes.cities.length)
                 && !(hotelRes.viewPoiList && hotelRes.viewPoiList.length)
                 && !(hotelRes.transportPoiList && hotelRes.transportPoiList.length)
                 && !(hotelRes.businessPoiList && hotelRes.businessPoiList.length)">
              <img src="../../../../assets/img/hotel-search-no.png">
            </div>
          </div>
        </div>
        <div class="main_content_item">
          <div>
            <p class="check_title">{{ $t('search.checkIn') }}</p>
            <p class="check_date">{{ date[0] }}</p>
          </div>
          <div>
            {{ ninghtCount }} {{ $t('search.night') }}
          </div>
          <div>
            <p class="check_title">{{ $t('search.checkOut') }}</p>
            <p class="check_date">{{ date[1] }}</p>
          </div>
          <el-date-picker v-model="date" style="width: 100%;height: 100%;opacity: 0;position: absolute;"
                          type="daterange"
                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                          value-format="yyyy-MM-dd" @change="selDate"
                          :picker-options="dateOptions" :clearable="false"></el-date-picker>
        </div>
        <div class="main_content_item" style="border-radius: 0 8px 8px 0">
          <div style="display: flex;align-items: center;">
            <i class="iconfont icon-diqiu" style="margin-left: 8px;font-size: 18px;font-weight: 500;color: #99a1af"/>
            <div class="keyword_box" style="flex: 1">
              <div style="color: #757575;font-size: 13px;margin-top: 6px">
                国籍
              </div>
              <el-select v-model="countryInfo.countryCode" placeholder="国籍" filterable clearable
                         :filter-method="filterCountry"
                         style="margin-top: 10px;width: 100%" @focus="focusCountry" @change="selCountry"
                         @clear="clearCountry">
                <el-option-group v-for="group in showCountryList" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
                    {{ item.label }}-{{ item.value }}
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
          </div>
          <div style="text-align: center;">
            <b2b-button class="b2b_button" @click="toSerch">
              <img src="@/assets/newImage/search_1.png" style="width: 20px;height: 20px;margin-right: 5px;">
              <span>{{ btnText }}</span>
            </b2b-button>
          </div>
          <div class="per_sel_box" v-show="isShowSelPer" @click.stop>
            <div style="margin-bottom: 20px;font-size: 15px;">
              <p class="sel_per_title">{{ $t('search.room') }}:</p>
              <el-input-number v-model="room" size="mini" :min="1" :max="4" label="房间数"
                               @change="changeCount"></el-input-number>
            </div>
            <div style="font-size: 15px;">
              <p class="sel_per_title">{{ $t('search.Adult') }}:</p>
              <el-input-number v-model="adult" size="mini" :min="1" :max="2" label="成人数"
                               @change="changeCount"></el-input-number>
            </div>
          </div>
        </div>
      </div>
      <div class="history_content">
        <SearchHotelHistory ref="searchHistory" @toHotelDetail="toHotelDetail" @toHotelList="toHotelList"/>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import CitySelect from './CitySelect.vue'
import CityList from './CityList.vue'
import HotelKeyWord from './HotelKeyWord.vue'
import SearchHotelHistory from './SearchHotelHistory.vue'

export default {
  data () {
    return {
      date: [],
      ninghtCount: 1,
      dateOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      showCitySel: false,
      showFilter: false,
      keyword: '',
      countryInfo: {
        countryName: '中国',
        countryCode: 'CN'
      },
      cityInfo: {
        cityCode: '',
        cityName: '',
        pinyin: ''
      },
      countDialogVisible: false,
      room: 1,
      adult: 2,
      isShowSelPer: false,
      regionId: 1,
      isShowKeyWord: false,
      hotelRes: [],
      isSearchHotel: false,
      isLengthError: false,
      allCity: [],
      showHistory: false,
      showCountryBox: false,
      filterCountryStr: ''
    }
  },
  props: {
    btnText: {
      btnText: String,
      default: '搜索'
    }
  },
  components: {
    CitySelect,
    CityList,
    HotelKeyWord,
    SearchHotelHistory
  },
  created () {
    this.getHistoryInfo()
    let regionId = sessionStorage.getItem('regionId')
    if (!regionId) {
      if (!this.$common.getAccountType()) {
        this.regionId = 1
      } else {
        this.regionId = this.$common.getAccountType() === 3 ? 1 : this.$common.getAccountType()
      }
    } else {
      this.regionId = Number(regionId)
    }
    document.addEventListener('click', (e) => {
      this.isShowKeyWord = false
      if (e.target.className !== 'city_select' && e.target.className !== 'sel') {
        this.showHistory = false
      }
    })
    this.getCityData()
  },
  mounted () {
    this.$refs['searchHistory'].init()
  },
  methods: {
    async getCityData () {
      let cityList = sessionStorage.getItem('allCity')
      if (!cityList) {
        const {data: allCity} = await this.$http.get('../../../../../static/mock/citysData.json')
        sessionStorage.setItem('allCity', JSON.stringify(allCity))
      }
    },
    getHistoryInfo () {
      const homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (homeSearchForm) {
        if (homeSearchForm.checkDates) {
          this.date = homeSearchForm.checkDates
        } else {
          this.getCheckDate()
        }
        if (new Date(this.date[0]).getTime() < new Date().getTime()) {
          this.getCheckDate()
        }
        this.cityInfo = homeSearchForm.cityInfo ? homeSearchForm.cityInfo : {}
        this.room = homeSearchForm.room
        this.adult = homeSearchForm.adult
        this.keyword = homeSearchForm.keyword
        this.regionId = homeSearchForm.regionId
      } else {
        this.getCheckDate()
      }
    },
    getCheckDate () {
      let currentDate = this.$common.formatterDate(new Date())
      let nextDate = this.$common.formatterDate(new Date(new Date().getTime() + 86400000))
      this.date[0] = currentDate
      this.date[1] = nextDate
      this.ninghtCount = this.$common.getNinghtCount(currentDate, nextDate)
    },
    selDate (e) {
      this.ninghtCount = this.$common.getNinghtCount(e[0], e[1])
    },
    toSelCity (e) {
      if (!e) {
        this.showFilter = false
        // let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
        // if (homeSearchForm) {
        //   if (homeSearchForm.cityInfo.cityName != this.cityInfo.cityName) {
        //     this.cityInfo.cityName = homeSearchForm.cityInfo.cityName
        //   }
        // }
      }
      this.showCitySel = e
    },
    selCity (e) {
      this.keyword = e.cityName
      this.cityInfo = e
      this.keyword = e.cityName
      this.regionId = e.regionId
      sessionStorage.setItem('regionId', this.regionId)
      let obj = {
        room: this.room,
        adult: this.adult,
        checkDates: this.date,
        checkIn: this.date[0],
        checkOut: this.date[1],
        keyword: this.keyword,
        regionId: this.regionId,
        cityType: true,
        cityCode: e.cityCode
      }
      obj.name = e.cityName
      sessionStorage.setItem('homeSearchForm', JSON.stringify(obj))
      this.isShowKeyWord = false
      this.showHistory = false
      this.$emit('toSerch')
    },
    blurInput () {
      this.showCitySel = false
      this.$refs.cityInput.blur()
    },
    inputCity () {
      this.showFilter = true
    },
    clearCity () {
      this.cityInfo = {}
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (homeSearchForm) {
        homeSearchForm.cityCode = ''
        sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
      }
      if (this.keyword) {
        this.inputKeyWord(this.keyword, true)
      }
    },
    toSerch () {
      if (!this.keyword) {
        this.$message.warning('请输入您想去的目的地。')
        this.focusKeyWordInput()
        this.$refs['keyWordInputRef'].focus()
        return
      }
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      let obj = {
        'room': this.room,
        'adult': this.adult,
        'checkDates': this.date,
        'checkIn': this.date[0],
        'checkOut': this.date[1],
        'keyword': this.keyword,
        'name': this.cityInfo.cityName,
        'cityCode': homeSearchForm && homeSearchForm.cityCode ? homeSearchForm.cityCode : '',
        'cityInfo': this.cityInfo ? this.cityInfo : {},
        'regionId': this.regionId
      }
      if (this.cityInfo && Object.keys(this.cityInfo).length) {
        obj.cityCode = this.cityInfo.cityCode
      }
      if (homeSearchForm) {
        obj.cityType = !!homeSearchForm.cityType
        obj.poiType = !!homeSearchForm.poiType
        obj.countryCode = homeSearchForm.countryCode
        if (obj.poiType) {
          obj.longitude = homeSearchForm.longitude
          obj.latitude = homeSearchForm.latitude
        }
      }
      sessionStorage.setItem('homeSearchForm', JSON.stringify(obj))
      this.$emit('toSerch')
      this.isShowKeyWord = false
      this.showHistory = false
      this.isShowKeyWord = false
    },
    changeCount () {
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (!homeSearchForm) return
      homeSearchForm.room = this.room
      homeSearchForm.adult = this.adult
      sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
    },
    clearType () {
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (!homeSearchForm) return
      homeSearchForm.cityType = false
      homeSearchForm.poiType = false
      sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
    },
    inputKeyWord (e, isClear) {
      if (isClear) {
        this.clearType()
      }
      if (!e) return this.isShowKeyWord = false
      this.$common.debounce(async () => {
        if (e.length < 2) {
          this.isLengthError = true
          this.isShowKeyWord = true
          return
        }
        let reqHeader = {
          accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
        }
        let req = {
          keyword: e,
          regionId: this.regionId,
          website: true
        }
        let partnerInfo = JSON.parse(this.$common.isLogin())
        if (!partnerInfo) {
          req.defaultUser = true
        }
        this.isSearchHotel = true
        const {data: result} = await this.$http.post('/mini/searchHotels', req, {headers: reqHeader})
        this.isSearchHotel = false
        if (result.code !== 200) return
        this.hotelRes = result.data
        this.isLengthError = false
        this.isShowKeyWord = true
        this.$nextTick(() => {
          let el = this.$refs['hotelKeyWordRef']
          if (el) {
            el.moveScroll()
          }
        })
      }, 100)
    },
    focusKeyWordInput () {
      this.showCountryBox = false
      if (this.keyword) {
        this.inputKeyWord(this.keyword, false)
        this.showHistory = false
      } else {
        setTimeout(() => {
          this.showHistory = true
        }, 300)
      }
    },
    blurKeyWordInput () {
      this.isShowKeyWord = false
      this.showHistory = false
    },
    focusCountry () {
      this.isShowKeyWord = false
    },
    selCountry (e) {
      this.countryInfo.countryCode = e
      let homeSearchFormStr = sessionStorage.getItem('homeSearchForm')
      if (homeSearchFormStr) {
        let homeSearchForm = JSON.parse(homeSearchFormStr)
        homeSearchForm.countryCode = this.countryInfo.countryCode
        sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
      }
      this.filterCountryStr = ''
    },
    clearCountry () {
      let homeSearchFormStr = sessionStorage.getItem('homeSearchForm')
      if (homeSearchFormStr) {
        let homeSearchForm = JSON.parse(homeSearchFormStr)
        this.$delete(homeSearchForm, 'countryCode')
        sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
      }
    },
    filterCountry (e) {
      this.filterCountryStr = e
    },
    clearKeyword () {
      this.isShowKeyWord = false
      this.$refs['searchHistory'].init()
      this.clearCity()
      this.clearType()
      setTimeout(() => {
        this.showHistory = true
      }, 100)
    },
    toHotelDetail (e) {
      let obj = {
        room: this.room,
        adult: this.adult,
        checkDates: this.date,
        checkIn: this.date[0],
        checkOut: this.date[1],
        cityCode: e.cityCode,
        channelId: null,
        regions: [],
        stars: [0],
        price: 0,
        siteType: 0,
        districtName: null,
        bizZoneName: null,
        starRating: null,
        hotelId: e.hotelId
      }
      localStorage.setItem('hotelDetailSearchForm', JSON.stringify(obj))
      window.open('/HotelDetail', '_blank')
    },
    toHotelList (e, type) {
      this.keyword = e.sourceNameCn ? e.sourceNameCn : e.sourceName
      this.regionId = e.cityCode.indexOf('KK') !== -1 ? 2 : 1
      sessionStorage.setItem('regionId', this.regionId)
      let obj = {
        room: this.room,
        adult: this.adult,
        checkDates: this.date,
        checkIn: this.date[0],
        checkOut: this.date[1],
        keyword: this.keyword,
        regionId: this.regionId,
        poiType: type === 'poi',
        cityType: type === 'city',
        longitude: e.longitude,
        latitude: e.latitude,
        cityCode: e.cityCode
      }
      obj.name = e.cityNameCn
      obj.cityInfo = {
        cityCode: e.cityCode,
        cityName: e.cityNameCn,
        country_name_cn: e.countryNameCn,
        country_name: e.countryNameCn
      }
      this.cityInfo = {...obj.cityInfo}
      sessionStorage.setItem('homeSearchForm', JSON.stringify(obj))
      this.isShowKeyWord = false
      this.showHistory = false
      this.$refs['keyWordInputRef'].blur()
      this.$emit('toSerch')
    },
    changeRegion (e) {
      this.regionId = e
      let homeSearchForm = JSON.parse(sessionStorage.getItem('homeSearchForm'))
      if (homeSearchForm) {
        homeSearchForm.regionId = e
        homeSearchForm.keyword = ''
        homeSearchForm.cityCode = ''
        homeSearchForm.cityType = false
        homeSearchForm.name = ''
        homeSearchForm.poiType = ''
        homeSearchForm.regionId = e
        sessionStorage.setItem('homeSearchForm', JSON.stringify(homeSearchForm))
      }
      sessionStorage.setItem('regionId', e)
      this.clearCity()
    }
  },
  watch: {
    'cityInfo.cityName' (val) {
      if (!val) return this.showFilter = false
    }
  },
  computed: {
    isLang () {
      return localStorage.getItem('lang') == 'en'
    },
    showCountryList () {
      let res = JSON.parse(JSON.stringify(this.$store.getters.getCountryList))
      if (!this.filterCountryStr) return res
      return res.filter(item => {
        item.options = item.options.filter(i => {
          return i.label.trim().toLowerCase().indexOf(this.filterCountryStr.trim().toLowerCase()) !== -1 || i.value.trim().toLowerCase().indexOf(this.filterCountryStr.trim().toLowerCase()) !== -1
        })
        return true
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main_body_search {
  display: grid;
  grid-template-columns: auto 1180px auto;

  .region_box {
    padding: 25px 20px 0 20px;
    display: flex;
    font-family: '苹方', serif;

    .region_item {
      cursor: pointer;
      padding: 12px 24px;
      background-color: rgba(240, 240, 241, .8);
      color: #4a5565;
      border-radius: 80px;
      margin-right: 15px;
      font-size: 13px;

      &:hover {
        background-color: rgba(240, 240, 241, .5);
      }

      &.active {
        font-size: 14px;
        background-color: #1e50f2;
        color: #FFFFFF;
        font-weight: bolder;
      }
    }
  }

  .main_content {
    background-color: #dadada;
    padding: 20px;
    position: relative;
    display: grid;
    grid-template-columns: 25.7% 32.3% 42%;

    .main_content_item {
      padding: 6px 0;
      background-color: #FFFFFF;
      border: 1px solid #e7e7e7;
      border-collapse: collapse;
      margin-right: -1px;
      font-family: '苹方';
      cursor: pointer;

      .check_title {
        margin-bottom: 14px;
        font-size: 13px;
        color: #757575;
      }

      .check_date {
        font-size: 14px;
        font-weight: bold;
      }

      /deep/ .el-input__inner:focus {
        box-shadow: none !important;
      }
    }

    .main_content_item:first-child {
      display: grid;
      grid-template-rows: repeat(2, auto);
      align-items: center;
      padding: 10px;
      position: relative;

      &.sel {
        border-bottom-color: #1e50f0;
        border-bottom-width: 2px;
      }

      /deep/ .el-input__inner {
        font-size: 14px;
        font-weight: 600;
        color: #000;
      }
    }

    .main_content_item:nth-child(2) {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      text-align: center;
      padding: 12px;
      position: relative;
      font-size: 13px;

      div:first-child {
        text-align: left;
      }

      div:nth-child(3) {
        text-align: right;
      }

      /deep/ .el-range-editor .el-range-input {
        cursor: pointer;
      }
    }

    .main_content_item:last-child {
      display: grid;
      grid-template-columns: 60% 40%;
      position: relative;

      .keyword_box {
        padding: 10px;
        position: relative;
        //border: 2px solid rgba(0, 0, 0, 0);

        &.sel {
          border-bottom-color: #1e50f0;
          border-bottom-width: 2px;
        }

        & /deep/ .el-input__icon {
          line-height: 20px !important;
        }

        .no_item {
          position: absolute;
          width: 535px;
          height: 200px;
          background-color: #fff;
          top: 92px;
          right: -232px;
          z-index: 50;
          box-shadow: 0 2px 2px #eaeaea;
          font-size: 15px;
          padding: 15px;
          text-align: center;
        }
      }

      .per_sel_box {
        position: absolute;
        width: 250px;
        padding: 20px;
        background-color: #fff;
        top: 70px;
        box-shadow: 0 2px 36px rgba(44, 55, 66, .15);

        .sel_per_title {
          font-family: '苹方';
          margin-bottom: 15px;
        }
      }

      .b2b_button {
        width: 144px;
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        margin-top: 5px;
        margin-left: 15px;
        border-radius: 8px;
        box-shadow: 0 8px 20px rgba(0, 82, 255, .3);
      }

      .sel_per {
        display: grid;
        grid-template-columns: repeat(2, auto);
        align-items: center;
        padding-left: 15px;
        grid-column-gap: 20px;
        border-right: 1px solid #e7e7e7;

        p:first-child {
          color: #757575;
          font-size: 12px;
          margin-bottom: 14px;
        }

        p:last-child {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
  }

  /deep/ .el-input__inner:focus {
    border: none;
  }

  /deep/ .el-input__inner {
    border: none;
    height: 20px;
    line-height: 20px;
    padding: 0;
    font-weight: bold;
    color: #000;
    font-size: 13px;
  }
}

.history_content {
  grid-column: 1 / -1;
  padding: 0 25px 10px 25px;
}

.new_filter_box {
  z-index: 999;
  position: absolute;
  left: -2px;
  margin-top: 25px;
}

.no_item {
  position: absolute;
  width: 535px;
  height: 200px;
  background-color: #fff;
  top: 88px;
  right: -242px;
  z-index: 50;
  box-shadow: 0 2px 2px #eaeaea;
  font-size: 15px;
  padding: 15px;
  text-align: center;
}

.country_box {
  position: absolute;
  width: 287px;
  height: 300px;
  background: #FFFFFF;
  left: -2px;
  margin-top: 13px;
  box-shadow: 0 2px 2px #eaeaea;
  overflow: auto;
  padding: 10px;

  .option_item:first-child {
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 10px;
  }

  .country_item {
    padding: 10px 0;

    &.active {
      background: #f5f7fa;
      color: #2959f1;
    }

    &:hover {
      background: #f5f7fa;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/components/SearchForm.vue